// Dense age format for Kanban board cards. Differs from relativeTime intentionally:
// no "ago" suffix, compound "Nh Mm" form, date fallback at 7d rather than month rollover.
const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	timeZone: 'UTC',
});

export function formatTicketAge(isoCreatedAt: string, now: Date = new Date()): string {
	const created = new Date(isoCreatedAt);
	const diffMs = now.getTime() - created.getTime();
	if (diffMs < 60_000) return 'just now';
	const minutes = Math.floor(diffMs / 60_000);
	if (minutes < 60) return `${minutes}m`;
	const hours = Math.floor(minutes / 60);
	if (hours < 24) {
		const remM = minutes - hours * 60;
		return remM === 0 ? `${hours}h` : `${hours}h ${remM}m`;
	}
	const days = Math.floor(hours / 24);
	if (days < 7) return `${days}d`;
	return DATE_FMT.format(created);
}
